import React from 'react';
import SubPage from '#/common/components/SubPage';
import { useSearchParams } from 'react-router-dom';
import TemplatePicker from '#/app/components/TemplatePicker';
import NewWorkOrderForm from '../components/NewWorkOrderForm';
import If from '#/common/components/If';
import useAssetQuery from '#/modules/asset/hooks/useAssetQuery';

const NewWorkOrderPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tenantIdFromParams = searchParams.get('tenantId') || undefined;
  const assetId = searchParams.get('assetId') || undefined;
  const templateId = searchParams.get('templateId');
  const findingId = searchParams.get('findingId') || undefined;
  const alertId = searchParams.get('alertId') || undefined;
  const isTemplateSelected = !!templateId && !!assetId;
  const title = 'New Work Order';

  const { data: assetQueryData, loading: assetLoading } = useAssetQuery(assetId ?? '', {
    skip: !!tenantIdFromParams,
  });
  const tenantIdFromAsset = assetQueryData?.getAsset?.data?.tenantId;

  if (!tenantIdFromParams && tenantIdFromAsset) {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('tenantId', tenantIdFromAsset);
    setSearchParams(newSearchParams, { replace: true });
  }

  return (
    <SubPage title={title} showGoBackButton type="form" isLoading={assetLoading}>
      <If condition={!isTemplateSelected && !findingId && !alertId}>
        <TemplatePicker assetId={assetId} />
      </If>
      <If condition={isTemplateSelected || !!findingId || !!alertId}>
        <NewWorkOrderForm
          title={title}
          findingId={findingId || ''}
          templateId={templateId || 'blank'}
          alertId={alertId || ''}
        />
      </If>
    </SubPage>
  );
};

export default React.memo(NewWorkOrderPage);
